import http from "./httpClient.js";

export async function generateSchedule(payloadToken, schoolId, danceStyleIds) {
    const response = await http.post(`/school/${schoolId}/schedule`, { danceStyleIds },{
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function getSchedule(payloadToken, schoolId) {
    const schedule = await http.get(`/school/${schoolId}/schedule`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        },
        params: {
            sort: 'date',
        }
    });
    return schedule.data;
}

export async function getScheduleDetailById(scheduleId, payloadToken, schoolId) {
    const schedule = await http.get(`/school/${schoolId}/schedule/${scheduleId}`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return schedule.data;
}

export async function takeAttendanceStudent(schoolId, scheduleId, subscriptionId, token) {
    const response = await http.post(`/school/${schoolId}/schedule/${scheduleId}/attendance-student`, {
        subscription: subscriptionId
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function takeAttendanceTeacher(schoolId, scheduleId, teacherId, token) {
    const response = await http.post(`/school/${schoolId}/schedule/${scheduleId}/attendance-teacher`, {
        teacher: teacherId
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

/**
 * Dashboard main view: today's and this week's classes for the selected school.
 * Requires auth and schoolId; backend must filter by school.
 */
export async function getClassesToMainView(token, schoolId) {
    const params = schoolId ? { schoolId } : {};
    const classes = await http.get(`/schedule`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        params,
    });
    return classes.data;
}

export async function getMyClassesByMySubscription(idUser, token, limit=100) {
    const teachers = await http.get(`/users/${idUser}/classesInSubscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {
            limit: limit
        }
    });
    return teachers.data;
}

export async function getScheduleDetailByIdForStudent(scheduleId, token) {
    const schedule = await http.get(`/schedule/${scheduleId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return schedule.data;
}

export async function generateQRToken(schoolId, scheduleId, token, userId) {
    const response = await http.get(`/school/${schoolId}/schedule/${scheduleId}/qr-code/${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function updateSchedule(token, schoolId, scheduleId, payload) {
    const response = await http.patch(`/school/${schoolId}/schedule/${scheduleId}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
}

export async function scanQRToken(schoolId, scheduleId, qrToken, token) {
    const response = await http.post(`/school/${schoolId}/schedule/${scheduleId}/scan-qr`, {
        qrToken: qrToken
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}